import { objectDuckCreator, createSelector, DuckSelector } from '@atc/modular-redux';

export default objectDuckCreator({
    namespace: 'DEALERLOT',
    storePrefix: 'dealerLot',
    store: 'content',
    initialState: {
        location: {},
        contextQuery: {},
        eLotQueryReady: false,
        recommendedInventoryQuery: {},
        fetchedDealerLot: false,
    },
}).extend({
    selectors: {
        fetchedDealerLot: (state) => state.dealerLotcontent.fetchedDealerLot,
        getOwner: (state) => {
            const { owner } = state.dealerLotcontent;
            if (owner?.logo) {
                owner.logo.alt = owner.name || 'owner logo';
            }
            return owner;
        },
        getLocation: (state) => state.dealerLotcontent.location,
        getElotQueryReady: (state) => state.dealerLotcontent.eLotQueryReady,
        getContextQuery: (state) => state.dealerLotcontent.contextQuery,
        getListings: new DuckSelector((selectors) => createSelector(
            [selectors.getOwner, (state) => state.dealerLotcontent.listings],
            (owner, listings) => listings?.map((item) => ({
                ...item,
            })) || [],
        )),
        getListingIds: new DuckSelector((selectors) => createSelector(
            selectors.getListings,
            (listings) => listings?.map((listing) => listing.id),
        )),
    },
});
